// Thema's (feat/themas), zie themesApp.nl.ts.
export const appThemesFr = {
    audience: 'Thème de ce tableau',
    audienceHint: 'Modifiable plus tard dans Tablettes, ou sur le tableau lui-même avec Modifier (aussi par écran).',
    adult: 'Famille et adultes',
    adultHint: 'Thème Adultes : calme et épuré, couleurs neutres et pictogrammes au trait.',
    kids: 'Enfants',
    kidsHint: 'Thème Enfants : pictogrammes colorés, boutons et texte plus grands. Si le tableau est dans la chambre des enfants, il ne montre que leurs affaires.',
    pictos: 'Pictogrammes dans l’app',
    pictosHint: 'S’applique à cet appareil.',
    pictosClean: 'Épuré (lignes calmes)',
    pictosColor: 'Ludique (coloré)',
};
//# sourceMappingURL=themesApp.fr.js.map